export default __webpack_public_path__ + "static/media/GuessJobs1_07.aac34020.png";